import { render, staticRenderFns } from "./change-winner.modal.vue?vue&type=template&id=987d4cc2&scoped=true"
import script from "./change-winner.modal.vue?vue&type=script&lang=js"
export * from "./change-winner.modal.vue?vue&type=script&lang=js"
import style0 from "./change-winner.modal.vue?vue&type=style&index=0&id=987d4cc2&prod&lang=scss&scoped=true"
import style1 from "./change-winner.modal.vue?vue&type=style&index=1&id=987d4cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987d4cc2",
  null
  
)

export default component.exports